/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Alert_TitleInputs */

const en_scene_change_detection_alert_title = /** @type {(inputs: Scene_Change_Detection_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot Change Detection`)
};

const fr_scene_change_detection_alert_title = /** @type {(inputs: Scene_Change_Detection_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detection de changement de plan`)
};

const de_scene_change_detection_alert_title = /** @type {(inputs: Scene_Change_Detection_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schusswechselerkennung`)
};

const it_scene_change_detection_alert_title = /** @type {(inputs: Scene_Change_Detection_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilevamento del cambio di tiro`)
};

const ru_scene_change_detection_alert_title = /** @type {(inputs: Scene_Change_Detection_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружение смены кадра`)
};

const es_scene_change_detection_alert_title = /** @type {(inputs: Scene_Change_Detection_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detección de cambios de disparo`)
};

const zh_cn2_scene_change_detection_alert_title = /** @type {(inputs: Scene_Change_Detection_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投篮变化检测`)
};

const ja_scene_change_detection_alert_title = /** @type {(inputs: Scene_Change_Detection_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショットチェンジ検出`)
};

const hi_scene_change_detection_alert_title = /** @type {(inputs: Scene_Change_Detection_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट परिवर्तन का पता लगाना`)
};

const pt_pt2_scene_change_detection_alert_title = /** @type {(inputs: Scene_Change_Detection_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detecção de mudança de tiro`)
};

/**
* | output |
* | --- |
* | "Shot Change Detection" |
*
* @param {Scene_Change_Detection_Alert_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_alert_title = /** @type {((inputs?: Scene_Change_Detection_Alert_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Alert_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_alert_title(inputs)
	if (locale === "de") return de_scene_change_detection_alert_title(inputs)
	if (locale === "it") return it_scene_change_detection_alert_title(inputs)
	if (locale === "ru") return ru_scene_change_detection_alert_title(inputs)
	if (locale === "es") return es_scene_change_detection_alert_title(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_alert_title(inputs)
	if (locale === "ja") return ja_scene_change_detection_alert_title(inputs)
	if (locale === "hi") return hi_scene_change_detection_alert_title(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_alert_title(inputs)
	return en_scene_change_detection_alert_title(inputs)
});